import { render, staticRenderFns } from "./PackageKidsAddDialog.vue?vue&type=template&id=067b0f64&scoped=true"
import script from "./PackageKidsAddDialog.vue?vue&type=script&lang=js"
export * from "./PackageKidsAddDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsAddDialog.vue?vue&type=style&index=0&id=067b0f64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b0f64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067b0f64')) {
      api.createRecord('067b0f64', component.options)
    } else {
      api.reload('067b0f64', component.options)
    }
    module.hot.accept("./PackageKidsAddDialog.vue?vue&type=template&id=067b0f64&scoped=true", function () {
      api.rerender('067b0f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsAddDialog.vue"
export default component.exports